import { PublicApiClient } from '@guiker/property-sale-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const usePublicApiClient = useAuthenticatedApiClient(PublicApiClient)
